import { Link } from "react-router-dom";
import { CLINIC } from "@/lib/clinic";
import SectionLabel from "@/components/SectionLabel";
import { Award, Building2, Languages, Calendar, Stethoscope, GraduationCap } from "lucide-react";

export default function Doctor() {
  return (
    <div>
      <section className="hero-gradient py-16 lg:py-24">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5 order-2 lg:order-1">
            <img src={CLINIC.doctor.photo} alt={CLINIC.doctor.name}
                 className="w-full rounded-[2rem] aarogya-shadow-lg border-8 border-white object-cover"
                 data-testid="doctor-photo" />
          </div>
          <div className="lg:col-span-7 order-1 lg:order-2">
            <SectionLabel>Meet the Doctor</SectionLabel>
            <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900">{CLINIC.doctor.name}</h1>
            <div className="mt-2 text-slate-600 text-lg">{CLINIC.doctor.quals} · {CLINIC.doctor.role}</div>

            <div className="mt-6 grid sm:grid-cols-2 gap-3">
              {[
                { icon: GraduationCap, k: "Qualifications", v: "MBBS · D.I.H. · AFIH" },
                { icon: Award,         k: "Experience",     v: "35+ years clinical practice" },
                { icon: Building2,     k: "Former Role",    v: "AGM (Medical), BHEL Bhopal" },
                { icon: Languages,     k: "Languages",      v: "English · Hindi" },
                { icon: Award,         k: "MP Med. Council", v: "Reg. No. 7768" },
              ].map((r, i) => (
                <div key={i} className="rounded-2xl bg-white border border-slate-200/70 p-4 aarogya-shadow">
                  <div className="flex items-center gap-3">
                    <r.icon className="h-5 w-5 text-[#0A6EBD]" />
                    <div>
                      <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500 font-semibold">{r.k}</div>
                      <div className="text-slate-800 font-semibold">{r.v}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <Link to="/appointment" className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold text-white"
                    style={{ background: "#0A6EBD" }} data-testid="doctor-book-btn">
                <Calendar className="h-4 w-4" /> Book with Dr. Onkar
              </Link>
              <Link to="/services" className="inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold text-slate-800 bg-white border border-slate-200">
                <Stethoscope className="h-4 w-4" /> Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 space-y-8">
          <div>
            <SectionLabel>Career Journey</SectionLabel>
            <p className="text-slate-700 leading-relaxed">
              Dr. V. K. Onkar completed his MBBS and later specialised in Industrial Health
              (D.I.H., AFIH), building an early career serving thousands of workers and their
              families at BHEL, Bhopal — where he rose to become Assistant General Manager
              (Medical). His experience across occupational and family medicine gives him a
              rare, holistic view of health.
            </p>
            <p className="mt-3 text-slate-700 leading-relaxed">
              Today, at Aarogya Clinic, he continues to practice with the same principles that
              have defined his career — honesty, evidence, and unhurried care.
            </p>
          </div>

          <div>
            <SectionLabel>Areas of Expertise</SectionLabel>
            <ul className="grid sm:grid-cols-2 gap-2 text-slate-700">
              {["Diabetes & metabolic health","Hypertension & cardiovascular risk","Chronic disease management","Fever & infection treatment","Preventive health checkups","Geriatric care","Occupational health & fitness certification","Lifestyle counselling"].map((x, i) => (
                <li key={i} className="flex items-start gap-2"><span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#0A6EBD]"></span>{x}</li>
              ))}
            </ul>
          </div>

          <div>
            <SectionLabel>Consultation Timings</SectionLabel>
            <div className="grid sm:grid-cols-2 gap-3">
              {CLINIC.hours.map((h, i) => (
                <div key={i} className="rounded-2xl border border-slate-200/70 p-4 bg-white aarogya-shadow">
                  <div className="text-sm font-semibold text-slate-800">{h.day}</div>
                  <div className="text-sm text-slate-600 mt-1">Evening: {h.evening}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
